// load mantine theme after tailwind
// https://v5.mantine.dev/theming/emotion-cache/

import { createEmotionCache } from '@mantine/core'

// https://github.com/mantinedev/mantine/issues/823#issuecomment-1172850808
const myCache = createEmotionCache({ key: 'mantine', prepend: false })

export default myCache
